package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminSyncRunResponse(
    val id: String,
    @SerialName("job_name") val jobName: String,
    @SerialName("started_at_utc") val startedAtUtc: String,
    @SerialName("finished_at_utc") val finishedAtUtc: String? = null,
    val status: String,
    @SerialName("records_updated") val recordsUpdated: Int,
    val error: String? = null,
    @SerialName("created_at_utc") val createdAtUtc: String
)
